import { Serializable } from '@/models/core/serializable';

export class DashboardInfo implements Serializable<DashboardInfo> {
  text: string;

  deserialize(input: any): DashboardInfo {
    this.text = input.text;
    return this;
  }

  get htmlText(): string {
    return this.text.replace(/\n/g, '<br/>');
  }
}
